module.exports = __webpack_public_path__ + "static/media/KT.3f65d86f.png";